'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { DataList } from '@morpho-org/ui-v6/client';
import type { ApiVaultWarning } from '@/helpers/warningTypes';
import type { VaultV1Risk } from '@/lib/procedures/vaultV1Risk.contract';
import { VaultTimelockedFunctionName } from '@/types/enums';
import type { PendingTimelock } from '../VaultHeroPendingActions/types';
import { CuratorTvlDataLine, TimelockDurationDataLine, VaultDeploymentDateDataLine, VaultVersionDataLine } from '../VaultRiskDisclosures/RiskDisclosure/components';
export interface VaultConfigurationClientProps {
  chainId: ChainId;
  curators: VaultV1Risk['curators'];
  /** Set when the curator list may be missing a curator. */
  curatorsPartial: boolean;
  factoryAddress: Address;
  timelock: number;
  creationTimestamp: number | null;
  warnings: ApiVaultWarning[];
  /** The vault's pending actions; empty when they could not be read. */
  pendingTimelocks: PendingTimelock[];
}
function VaultConfigurationClient(t0) {
  const $ = _c(30);
  const {
    chainId,
    curators,
    curatorsPartial,
    factoryAddress,
    timelock,
    creationTimestamp,
    warnings,
    pendingTimelocks
  } = t0;
  let t1;
  if ($[0] !== pendingTimelocks) {
    t1 = pendingTimelocks.filter(_temp);
    $[0] = pendingTimelocks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pendingSetTimelockTimelocks = t1;
  let t2;
  if ($[2] !== curators) {
    t2 = curators.map(_temp2);
    $[2] = curators;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formattedCurators = t2;
  let t3;
  if ($[4] !== chainId || $[5] !== factoryAddress) {
    t3 = <VaultVersionDataLine chainId={chainId} factoryAddress={factoryAddress} />;
    $[4] = chainId;
    $[5] = factoryAddress;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = creationTimestamp ?? undefined;
  let t5;
  if ($[7] !== t4) {
    t5 = <VaultDeploymentDateDataLine creationTimestamp={t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <DataList.Column>{t3}{t5}</DataList.Column>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== formattedCurators) {
    t7 = formattedCurators.length > 0 && <CuratorTvlDataLine curators={formattedCurators} />;
    $[12] = formattedCurators;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== chainId || $[15] !== pendingSetTimelockTimelocks || $[16] !== timelock || $[17] !== warnings) {
    t8 = <TimelockDurationDataLine chainId={chainId} pendingTimelocks={pendingSetTimelockTimelocks} timelock={timelock} warnings={warnings} />;
    $[14] = chainId;
    $[15] = pendingSetTimelockTimelocks;
    $[16] = timelock;
    $[17] = warnings;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <DataList.Column>{t7}{t8}</DataList.Column>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t6 || $[23] !== t9) {
    t10 = <DataList.Root fullWidth={true}>{t6}{t9}</DataList.Root>;
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== curatorsPartial) {
    t11 = curatorsPartial && <p className="text-secondary-foreground text-xs" data-testid="vault-configuration-curators-partial">Some curators could not be loaded, so the curator list may be incomplete.</p>;
    $[25] = curatorsPartial;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}
function _temp2(t0) {
  const {
    aumUsd,
    ...curator
  } = t0;
  return {
    ...curator,
    aum: aumUsd ?? undefined
  };
}
function _temp(item) {
  return item.functionName === VaultTimelockedFunctionName.SetTimelock;
}
export default VaultConfigurationClient;